{
  "title": "الفريق",
  "description": "أعضاء فريقك وأدوارهم، والدعوات، وسياسة الأمان.",
  "invite": {
    "button": "دعوة عضو",
    "title": "دعوة أعضاء إلى الفريق",
    "description": "نرسل لكل شخص رابط دعوة صالح لمدة 7 أيام.",
    "emails": "البريد الإلكتروني",
    "emailsHint": "حتى 10 عناوين، افصل بينها بفاصلة أو مسافة.",
    "role": "الدور",
    "message": "رسالة مع الدعوة",
    "messagePlaceholder": "مثلًا: أضفناك لمتابعة السيرفرات الجديدة.",
    "submit": "أرسل الدعوة",
    "demoHint": "في النسخة التجريبية، يقبل المدعو الدعوة تلقائيًا بعد 25 ثانية تقريبًا.",
    "errors": {
      "invalid": "هذا البريد غير صحيح: {{email}}",
      "tooMany": "الحد الأقصى 10 دعوات في المرة الواحدة.",
      "member": "{{email}} عضو في الفريق بالفعل.",
      "invited": "{{email}} لديه دعوة سارية. أعد إرسالها من قائمة الدعوات."
    },
    "submitMany_zero": "أرسل الدعوات",
    "submitMany_one": "أرسل الدعوة",
    "submitMany_two": "أرسل الدعوتين",
    "submitMany_few": "أرسل {{count}} دعوات",
    "submitMany_many": "أرسل {{count}} دعوة",
    "submitMany_other": "أرسل {{count}} دعوة",
    "sent_zero": "لم تُرسل أي دعوة",
    "sent_one": "تم إرسال الدعوة",
    "sent_two": "تم إرسال دعوتين",
    "sent_few": "تم إرسال {{count}} دعوات",
    "sent_many": "تم إرسال {{count}} دعوة",
    "sent_other": "تم إرسال {{count}} دعوة"
  },
  "members": {
    "caption": "أعضاء الفريق",
    "search": "ابحث بالاسم أو البريد",
    "columns": {
      "member": "العضو",
      "role": "الدور",
      "twoFactor": "المصادقة الثنائية",
      "lastActive": "آخر نشاط",
      "joined": "انضم في"
    },
    "you": "أنت",
    "twoFactorOn": "مفعّلة",
    "twoFactorOff": "غير مفعّلة",
    "never": "لم يسجّل الدخول بعد",
    "empty": "لا يوجد أعضاء بعد",
    "readOnly": "دورك {{role}}، لذلك يمكنك عرض الفريق فقط. إدارة الأعضاء والدعوات للمالك والمدير."
  },
  "actions": {
    "changeRole": "تغيير الدور",
    "remove": "إزالة من الفريق",
    "leave": "مغادرة الشركة"
  },
  "changeRole": {
    "title": "تغيير الدور",
    "description": "اختر دور {{name}} الجديد. يُطبَّق فورًا.",
    "submit": "حفظ الدور"
  },
  "remove": {
    "title": "إزالة العضو؟",
    "description": "يفقد {{name}} الوصول إلى {{org}} فورًا، وتنتهي جلساته المفتوحة. يمكنك دعوته مرة أخرى لاحقًا.",
    "confirm": "إزالة العضو"
  },
  "leave": {
    "title": "مغادرة {{org}}؟",
    "description": "تفقد الوصول إلى السيرفرات والفواتير والتذاكر في هذه الشركة، ولن تعود إلا بدعوة جديدة.",
    "confirm": "مغادرة الشركة"
  },
  "invitations": {
    "title": "الدعوات",
    "sentBy": "أرسلها {{name}}، {{when}}",
    "expired": "انتهت",
    "actions": "إجراءات دعوة {{email}}",
    "resend": "إعادة الإرسال",
    "resendExpired": "إرسال دعوة جديدة",
    "copyLink": "نسخ رابط الدعوة",
    "revoke": "إلغاء الدعوة",
    "linkCopied": "تم نسخ رابط الدعوة",
    "linkCopyManual": "انسخ رابط الدعوة",
    "revokeTitle": "إلغاء الدعوة؟",
    "revokeDescription": "سيتوقف الرابط المرسل إلى {{email}} عن العمل.",
    "description_zero": "لا توجد دعوات مفتوحة.",
    "description_one": "دعوة واحدة لم تُقبل بعد.",
    "description_two": "دعوتان لم تُقبلا بعد.",
    "description_few": "{{count}} دعوات لم تُقبل بعد.",
    "description_many": "{{count}} دعوة لم تُقبل بعد.",
    "description_other": "{{count}} دعوة لم تُقبل بعد.",
    "expires_zero": "تنتهي اليوم",
    "expires_one": "تنتهي بعد يوم",
    "expires_two": "تنتهي بعد يومين",
    "expires_few": "تنتهي بعد {{count}} أيام",
    "expires_many": "تنتهي بعد {{count}} يومًا",
    "expires_other": "تنتهي بعد {{count}} يوم"
  },
  "policy": {
    "title": "سياسة الأمان",
    "description": "تنطبق على كل أعضاء الشركة.",
    "label": "إلزام كل الأعضاء بالمصادقة الثنائية",
    "hint": "من لم يفعّلها يُطلب منه إعدادها عند تسجيل الدخول القادم.",
    "updatedBy": "فعّلها {{name}}، {{when}}",
    "setUp": "فعّل المصادقة الثنائية",
    "needYour2fa": "فعّل المصادقة الثنائية لحسابك أولًا، ثم ألزم بها الفريق.",
    "readOnly": "تغيير هذه السياسة متاح للمالك والمدير فقط.",
    "enableTitle": "إلزام الفريق بالمصادقة الثنائية؟",
    "disableTitle": "إيقاف إلزام المصادقة الثنائية؟",
    "disableDescription": "سيتمكن الأعضاء من الدخول بكلمة المرور وحدها. ننصح بإبقاء الإلزام لأن الحساب يضم مفاتيح التفعيل والفواتير.",
    "enable": "إلزام الفريق",
    "disable": "إيقاف الإلزام",
    "membersWithout_zero": "كل الأعضاء فعّلوا المصادقة الثنائية.",
    "membersWithout_one": "عضو واحد لم يفعّل المصادقة الثنائية.",
    "membersWithout_two": "عضوان لم يفعّلا المصادقة الثنائية.",
    "membersWithout_few": "{{count}} أعضاء لم يفعّلوا المصادقة الثنائية.",
    "membersWithout_many": "{{count}} عضوًا لم يفعّلوا المصادقة الثنائية.",
    "membersWithout_other": "{{count}} عضو لم يفعّلوا المصادقة الثنائية.",
    "enableDescription_zero": "سيُطلب رمز المصادقة الثنائية من كل عضو عند تسجيل الدخول. كل الأعضاء فعّلوها بالفعل.",
    "enableDescription_one": "سيُطلب رمز المصادقة الثنائية من كل عضو عند تسجيل الدخول. عضو واحد لم يفعّلها، وسنطلب منه إعدادها في دخوله القادم قبل أن يتابع.",
    "enableDescription_two": "سيُطلب رمز المصادقة الثنائية من كل عضو عند تسجيل الدخول. عضوان لم يفعّلاها، وسنطلب منهما إعدادها في الدخول القادم قبل المتابعة.",
    "enableDescription_few": "سيُطلب رمز المصادقة الثنائية من كل عضو عند تسجيل الدخول. {{count}} أعضاء لم يفعّلوها، وسنطلب منهم إعدادها في الدخول القادم قبل المتابعة.",
    "enableDescription_many": "سيُطلب رمز المصادقة الثنائية من كل عضو عند تسجيل الدخول. {{count}} عضوًا لم يفعّلوها، وسنطلب منهم إعدادها في الدخول القادم قبل المتابعة.",
    "enableDescription_other": "سيُطلب رمز المصادقة الثنائية من كل عضو عند تسجيل الدخول. {{count}} عضو لم يفعّلوها، وسنطلب منهم إعدادها في الدخول القادم قبل المتابعة."
  },
  "matrix": {
    "title": "الأدوار والصلاحيات",
    "description": "صلاحيات كل دور في حساب شركتك.",
    "roleLabel": "اختر الدور",
    "capability": "الصلاحية",
    "yourRole": "دورك",
    "yes": "مسموح",
    "no": "غير مسموح",
    "caps": {
      "servers_view": "عرض السيرفرات وحالتها",
      "support_use": "فتح تذاكر الدعم والرد عليها",
      "releases_view": "عرض الإصدارات وملاحظاتها",
      "servers_manage": "إضافة السيرفرات وتثبيتها ونقلها وإدارة مفاتيح التفعيل",
      "diagnostics_share": "مشاركة بيانات التشخيص مع الدعم",
      "billing_manage": "تغيير الباقة وطرق الدفع والفواتير وبيانات الفوترة",
      "credits_manage": "شراء نقاط الذكاء الاصطناعي وإعداداتها",
      "servers_cancel": "إلغاء اشتراك سيرفر أو استئنافه، وحذف سيرفر لم يتفعّل",
      "team_manage": "دعوة الأعضاء وإدارة أدوارهم",
      "org_manage": "بيانات الشركة وسياسة الأمان",
      "org_owner": "نقل الملكية وحذف الشركة"
    }
  },
  "transfer": {
    "title": "نقل الملكية",
    "description": "يحصل المالك الجديد على كل الصلاحيات، وتصبح أنت مديرًا.",
    "member": "المالك الجديد",
    "pick": "اختر عضوًا",
    "none": "لا يوجد أعضاء آخرون",
    "needs2fa": "يجب أن يفعّل المصادقة الثنائية أولًا",
    "button": "نقل الملكية",
    "memberHint": "يجب أن تكون المصادقة الثنائية مفعّلة لدى المالك الجديد.",
    "confirmTitle": "نقل الملكية؟",
    "confirmDescription": "يصبح {{name}} المالك، وتصبح أنت مديرًا. لا يمكنك استعادة الملكية إلا إذا نقلها إليك المالك الجديد.",
    "confirm": "نقل الملكية"
  },
  "toasts": {
    "roleChanged": "تم تغيير الدور",
    "removed": "تمت إزالة العضو",
    "transferred": "تم نقل الملكية",
    "resent": "تمت إعادة إرسال الدعوة",
    "revoked": "تم إلغاء الدعوة",
    "left": "غادرت {{org}}"
  },
  "accept": {
    "documentTitle": "دعوة للانضمام",
    "loading": "جارٍ تحميل الدعوة",
    "title": "انضم إلى {{org}}",
    "description": "دعاك {{inviter}} للانضمام إلى فريق {{org}} على bPanel.",
    "organization": "الشركة",
    "invitedBy": "الدعوة من",
    "role": "دورك",
    "email": "البريد الإلكتروني",
    "expires": "الدعوة صالحة حتى {{date}}.",
    "join": "قبول والدخول إلى {{org}}",
    "existing": "لديك حساب بالبريد {{email}}. سجّل الدخول لقبول الدعوة.",
    "signInToAccept": "سجّل الدخول لقبول الدعوة",
    "createTitle": "أنشئ حسابك",
    "name": "الاسم الكامل",
    "password": "كلمة المرور",
    "createAndJoin": "إنشاء الحساب والانضمام",
    "haveAccount": "لديك حساب بهذا البريد؟",
    "signIn": "سجّل الدخول",
    "home": "العودة إلى الرئيسية",
    "notFound": {
      "title": "لم نعثر على الدعوة",
      "body": "تأكد من فتح الرابط كاملًا من رسالة الدعوة، أو اطلب دعوة جديدة."
    },
    "closed": {
      "expired": {
        "title": "انتهت صلاحية الدعوة",
        "body": "الدعوة إلى {{org}} صالحة لمدة 7 أيام. اطلب من {{inviter}} أن يرسل لك دعوة جديدة."
      },
      "revoked": {
        "title": "تم إلغاء الدعوة",
        "body": "أُلغيت الدعوة إلى {{org}}. إذا كنت تتوقع الانضمام، تواصل مع {{inviter}}."
      },
      "accepted": {
        "title": "قُبلت هذه الدعوة سابقًا",
        "body": "أنت عضو في {{org}}. سجّل الدخول للمتابعة."
      }
    },
    "mismatch": {
      "title": "الدعوة مرسلة إلى بريد آخر",
      "body": "سجّلت الدخول بالبريد {{current}}، لكن الدعوة مرسلة إلى {{email}}.",
      "signOut": "تسجيل الخروج والمتابعة"
    }
  }
}
